module.exports = __webpack_public_path__ + "img/00_Habilitaciones - INAL.6c261b07.jpg";